import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.677 3.489a.84.84 0 0 0-.59.244L4.16 10.66l-.394 1.574 1.574-.394 6.926-6.925a.834.834 0 0 0-.59-1.425m-1.643-.808a2.323 2.323 0 1 1 3.285 3.285l-7.07 7.072a.74.74 0 0 1-.347.195l-2.977.745a.744.744 0 0 1-.903-.903l.745-2.977c.032-.131.1-.25.195-.346z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })